module.exports = __webpack_public_path__ + "img/operate2.b2a32743.png";